export const getInvoiceIdentifier = (invoice) => {
  const { number, serie, content_declaration } = invoice || {};

  return content_declaration || [number, serie].join('-');
};

export const getInvoiceLabel = (invoice) => {
  const { content_declaration } = invoice || {};
  if (content_declaration) {
    return 'Declaração de conteúdo';
  }
  return 'Nota fiscal';
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/helpers/invoiceValuesHelper.js